import request from '../utils/service'

const api = {
  getNearbyParks: function(data) {
    return request({
      url: '/dealer/v2/api/nearbyParks',
      method: 'post',
      data: data
    })
  },
  getNearbyDiffTimeParks: function(data) {
    return request({
      url: '/dealer/v2/api/nearbyDiffTimeParks',
      method: 'post',
      data: data
    })
  },
  getCityList: function() {
    return request({
      url: '/dealer/v2/api/citys',
      method: 'get'
    })
  },
  getConfigs: function() {
    return request({
      url: '/basic/v2/api/paramConfigs',
      method: 'get'
    })
  },
  getNearbyStations: function(data) { // 充电站
    return request({
      url: '/cps/v2/api/nearbyStations',
      method: 'post',
      data: data
    })
  },
  getMapType: function() { // 获取默认地图类型高德、百度
    return request({
      url: '/basic/v2/api/sysCodes/getMapType',
      method: 'get'
      // params: data
    })
  },
  collectParks: function(data) { // 获取停车场收藏列表
    return request({
      url: '/dealer/v2/api/collectParks',
      method: 'get',
      params: data
    })
  },
  saveCollectParks: function(data) { // 收藏停车场
    return request({
      url: '/dealer/v2/api/collectParks',
      method: 'post',
      data: data
    })
  },
  delCollectParks: function(parkId) { // 取消收藏停车场
    return request({
      url: `/dealer/v2/api/collectParks/${parkId}`,
      method: 'delete'
    })
  },
  collectStations: function(data) { // 获取充电站收藏列表
    return request({
      url: '/cps/v2/api/collectStations',
      method: 'get',
      params: data
    })
  },
  saveCollectStations: function(data) { // 收藏充电站
    return request({
      url: '/cps/v2/api/collectStations',
      method: 'post',
      data: data
    })
  },
  delCollectStations: function(stationId) { // 取消收藏充电站
    return request({
      url: `/cps/v2/api/collectStations/${stationId}`,
      method: 'delete'
    })
  },
  nearbySearchByName: function(data) { // 按名称搜索场站
    return request({
      url: '/dealer/v2/api/nearbySearchByName',
      method: 'post',
      data: data
    })
  },
  getNearbyBookParks: function(data) {
    return request({
      url: '/dealer/v2/api/nearByCanBookParks',
      method: 'post',
      data: data
    })
  }
}

export default api
